import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService} from '../../_services/index';
import {User} from '../../_models/index';


import {Customs, LoginHelper, Role,} from '../../helpers';
import {Constants} from "../../helpers/constants";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

const now = new Date();

@Component({
    standalone: false,
  selector: 'user-popup-component',
  templateUrl: 'user-popup.component.html',
  styleUrls: ['./user-popup.component.scss'],
})

export class UserPopupComponent implements OnInit {
  loading = false;
  userId: number;
  user: User;
  public externalRoles = null;

  constructor(
    public dialogRef: MatDialogRef<UserPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public alertService: AlertService) {

    this.userId = route.snapshot.params['userId'];
    this.externalRoles = data['roles'];
  }


  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    if (this.data.user.userId) {
      this.userService.getById(this.data.user.userId).subscribe(
        data => {
          this.user = data;
        });
    } else {
      this.user = <any>{userId: null};
    }
  }
}
